var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00705 17.7682L4.69812 3.05122C4.76483 2.47065 5.28731 2 5.86511 2H10.573C13.1731 2 15.0375 4.11791 14.7373 6.73047C14.4371 9.34304 12.086 11.4609 9.48587 11.4609H7.91657L7.19183 17.7682C7.12512 18.3488 6.60264 18.8195 6.02484 18.8195H3.93245C3.35466 18.8195 2.94034 18.3488 3.00705 17.7682Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67369 18.2098L8.23801 20.9488C8.17129 21.5294 8.58561 22 9.16341 22H11.2558C11.8336 22 12.3561 21.5294 12.4228 20.9488L13.1476 15.6941H14.7168C17.3169 15.6941 19.6681 13.5762 19.9683 10.9636C20.2473 8.53556 18.6566 6.53476 16.3433 6.26428C16.3368 6.41828 16.3246 6.57382 16.3066 6.7307C15.9063 10.2141 12.7715 13.038 9.30466 13.038L8.7611 17.7685C8.74383 17.9189 8.71432 18.0663 8.67369 18.2098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.5508a886ea33e7a6aaf272049c6afb23.svg";
export { ForwardRef as ReactComponent };